import { render, staticRenderFns } from "./changYongBiaoDa.vue?vue&type=template&id=027e7324&scoped=true&"
import script from "./changYongBiaoDa.vue?vue&type=script&lang=js&"
export * from "./changYongBiaoDa.vue?vue&type=script&lang=js&"
import style0 from "./changYongBiaoDa.vue?vue&type=style&index=0&id=027e7324&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e7324",
  null
  
)

export default component.exports